// extracted by mini-css-extract-plugin
export default {"AllBgColor":"LoginPage_AllBgColor__q3EBs","loginCol":"LoginPage_loginCol__OocVj"};